export default __webpack_public_path__ + "static/media/discord.3fb1d1b5.svg";